import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, Button } from '@mui/material';
import { useIntl } from 'react-intl';
import { useDialog } from '../../contexts/DialogContext';
import sessionTimeout from 'assets/images/session-timeout.svg';
const ResponseDialog = () => {
  const intl = useIntl();
  const { dialogOpen, hideDialog, dialogData } = useDialog();
  const resolvedTitle = intl?.messages?.[dialogData.title]
    ? intl.formatMessage({ id: dialogData.title, defaultMessage: dialogData.title })
    : dialogData.title;
  const resolvedContent = intl?.messages?.[dialogData.content]
    ? intl.formatMessage({ id: dialogData.content, defaultMessage: dialogData.content })
    : dialogData.content;

  return (
    <Dialog open={dialogOpen} aria-labelledby="responsive-dialog-title">
      <DialogTitle
        id="responsive-dialog-title"
        sx={{
          minWidth: '500px',
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
          justifyContent: 'center',
          gap: 2.5
        }}
      >
        <img src={sessionTimeout} alt="Session Timeout" id="SessionTimeout" />
        <Typography variant="h1" sx={{ fontWeight: '500' }}>
          {resolvedTitle}
        </Typography>
      </DialogTitle>
      <DialogContent
        sx={{
          minHeight: '50px',
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
          justifyContent: 'center'
        }}
      >
        <Typography variant="body1" color="grey.500" sx={{ letterSpacing: '0.17px', textAlign: 'center' }}>
          {resolvedContent}
        </Typography>
      </DialogContent>
      <DialogActions
        sx={{
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
          justifyContent: 'center',
          paddingBottom: '12px'
        }}
      >
        {dialogData.calledFrom == 'useApi' && (
          <Button variant="contained" onClick={hideDialog}>
            {intl.formatMessage({ id: 'signInAgain', defaultMessage: 'Sign-In Again' })}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default ResponseDialog;
